var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseLine = function SvgCloseLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 451.67 211.2-211.2 60.373 60.373-211.2 211.2 211.2 211.2-60.373 60.33-211.2-211.2-211.2 211.2-60.288-60.373 211.2-211.2-211.2-211.2 60.288-60.245 211.2 211.2z"
  })));
};
export default SvgCloseLine;